import { render, staticRenderFns } from "./job-tab.vue?vue&type=template&id=5b2af1ba&scoped=true"
import script from "./job-tab.vue?vue&type=script&lang=js"
export * from "./job-tab.vue?vue&type=script&lang=js"
import style0 from "./job-tab.vue?vue&type=style&index=0&id=5b2af1ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2af1ba",
  null
  
)

export default component.exports